import { Component, OnInit } from '@angular/core';

import { InviteService } from '../../services/invite.service';
import { GroupService } from '../../services/group.service';
import { NaviService } from '../../services/navi.service';

import { Study } from '../../models/study';
import { BasicError } from '../../models/error/error';

@Component({
  selector: 'app-invites',
  templateUrl: './invites.component.html',
  styleUrls: ['./invites.component.css']
})
export class InvitesComponent implements OnInit {
  public arrayInv = [];
  public arrayStud = [];
  public studyToInviteMap = {};

  public isLoaded: Boolean = false;
  public showTable: Boolean = false;

  public myObj = [];
  public canSubscribe = true;
  public amountStudies;

  public navigateToMyHCP: String = '/mygroups';

  constructor(private inviteService: InviteService, private groupService: GroupService, private naviService: NaviService) { }

  ngOnInit() {
    this.getGroups();

    this.inviteService.getMyInvitations().subscribe(data => {
      if (data instanceof BasicError) {
        console.log(data);
        this.isLoaded = false;
        this.showTable = false;
      } else {
        this.arrayInv = data;
        this.isLoaded = true;

        if (this.isLoaded) {
          for (let i = 0; i < this.arrayInv.length; i++) {
            const inv = this.arrayInv[i];
            this.groupService.getGroupDetail(this.arrayInv[i].getModelId()).subscribe(studydata => {
              if (studydata instanceof BasicError) {
                console.log(studydata);
                this.showTable = false;
              } else {
                this.arrayStud[i] = studydata;

                if (studydata instanceof Study) {
                  this.studyToInviteMap[studydata.getId().toString()] = inv;
                }

                if (this.arrayStud.length > 0) {
                  this.showTable = true;
                }
              }
            });
          }
        }
      }
    });


  }

  public getExpireDate(no: Number) {
    if (no === undefined || no === null) {
      return 0;
    }

    const exDate = new Date(no.valueOf() * 1000);
    exDate.setDate(exDate.getDate());
    let date;
    date = (exDate.getDate() > 9) ? exDate.getDate() + '.' : '0' + exDate.getDate() + '.';
    date = ((exDate.getMonth() + 1) > 9) ? date + (exDate.getMonth() + 1) : date + '0' + (exDate.getMonth() + 1);
    date = date + '.';
    date = date + exDate.getFullYear();
    return date;
  }

  public getExpiresTime(no: Number) {
    if (no === undefined || no === null) {
      return 0;
    }

    const exTime = new Date(no.valueOf() * 1000);
    const time = ('0' + exTime.getHours()).slice(-2) + ':' + ('0' + exTime.getMinutes()).slice(-2) + (' Uhr');
    return time;
  }

  public acceptInvite(invite) {
    this.inviteService.acceptInvitation(invite).subscribe(data => {
      if (data) {
        this.navigateToMyGroups();
      } else {
        console.log('Invite Accept failed!');
      }
    });
  }

  public getGroups() {
    this.groupService.getMyGroups().subscribe(data => {
      this.myObj = data;
      this.amountStudies = data.length

      if (this.amountStudies >= 2) {
        this.canSubscribe = false;
      } else {
        this.canSubscribe = true;
      }
    });
  }

  public navigateToMyGroups() {
    this.naviService.navigateToUrl(this.navigateToMyHCP, 'mygroups');
  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/invites/invites.component.ts